import { store } from '../../../../../resources/frontend/js/store';
import { sbPopup } from '../../../js/vue-flows/default-components/sb-popup/v1/sb-popup-1.1.0';

export const setInvalid = element => {
    sbPopup(store.state.page.notificationText, 'error');
    element.classList.add('invalid');

    removeInvalid(element);
};

export const removeInvalid = element => {
    const listenToClick = event => {
        event.target.removeEventListener(event.type, listenToClick);
        element.classList.remove('invalid');
    };

    element.addEventListener('click', listenToClick);
};
